/**
 * Created by Maria on 13/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorPositions', {
                parent: 'masterData',
                url: '/sectorPositions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/sectorPositions/sectorPositions.html',
                        controller: 'MDSectorPositionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
